import {
  Dialog,
  DialogContent,
  Typography,
  Box,
  useTheme,
  Divider,
} from "@mui/material";
import ButtonComp from "./Button";
import FileUpload from "./FileUpload";
import { useState } from "react";

type SubmitPopup = {
  open: boolean;
  onClose: () => void;
  onSubmit: any;
  getPopFile: (value: any) => void;
  popFileName: any;
  type: string;
  batchNo: string | null;

};

export const BulkPaymentPopup = ({
  open,
  onClose,
  onSubmit,
  popFileName,
  getPopFile,
  type,
  batchNo,
}: SubmitPopup) => {
  const theme = useTheme();
  const [fileAttached, setFileAttached] = useState(false);

  return (
    <Dialog
      maxWidth={false}
      open={open}
      onClose={onClose}
      aria-labelledby="finance-dialog-title"
      aria-describedby="finance-dialog-description"
      slotProps={{
        paper: {
          sx: {
            borderRadius: 4,
            overflow: "hidden",
            width: { xs: "95%", sm: 800 },
          },
        },
      }}
    >
      {/* Header */}
      <Box
        sx={{
          backgroundColor: "#F26522",
          height: 60,
          display: "flex",
          alignItems: "center",
          px: 2,
          position: "relative",
        }}
      ></Box>

      {/* Content */}
      <DialogContent
        sx={{
          backgroundColor: theme.palette.background.default,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <Typography
        variant="body2"
          sx={{
            color:"#EC6E00" ,
            fontWeight: 600,
            fontSize: 16,
          }}>
          {type === "Cash Payout"
            ? "Cash Payout"
            : type === "Service Payout"
            ? "Service Payout"
            : "10% Payout"}
        </Typography>
        {/* Banking Details Card */}
        <Box
          sx={{
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.15)",
            borderRadius: 2,
            backgroundColor: "#fff",
            p: 3,
            mt: 2,
          }}
        >
          <Box
            display="grid"
            gridTemplateColumns={{
              xs: "1fr", // 1 column on extra-small screens
              sm: "repeat(2, 1fr)", // 2 columns on small screens
              md: "repeat(3, 1fr)", // 3 columns on medium and above
            }}
            rowGap={2}
            columnGap={2}
          ></Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
              mt: 2,
            }}
          >
            <Typography variant="body1" fontWeight={600} fontSize={18}>
              Attach proof of payment
            </Typography>
            <FileUpload
              inputId="finance-file-upload"
              fileName={popFileName?.name ?? "No file chosen"}
              onChange={async (e) => {
                const selectedFile = e.target.files?.[0];
                getPopFile(selectedFile);
                setFileAttached(!!selectedFile);
              }}
            />
          </Box>
        </Box>
        <Box
          display="flex"
          gap={2}
          mt={2}
          justifyContent="flex-start"
          flexDirection={{ xs: "column", sm: "row" }}
        >
          <ButtonComp
            variant="success"
            height={40}
            width={190}
            onClick={() => {
              onClose();
              onSubmit(batchNo, popFileName);
            }}
            disabled={!fileAttached}
          >
            PAY
          </ButtonComp>
          <ButtonComp
            variant="error"
            height={40}
            width={190}
            onClick={() => {
              onClose();
              
            }}
          >
            CANCEL
          </ButtonComp>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
const LabelValue = ({ label, value }: { label: string; value: string }) => (
  <Box>
    <Typography fontWeight={600} fontSize={20}>
      {label}
    </Typography>
    <Typography fontSize={20}>{value}</Typography>
  </Box>
);
